import { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { DataProvider, GridLayoutProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'

interface CustomRecyclerViewProps {
  data: any[]
  type?: number
  renderItem: any
  ListEmptyComponent?: any
  nativeID?: string
  numColumns?: number
  itemHeight?: number
  extendedState?: any
}

const CustomRecyclerView = ({
  data,
  renderItem,
  ListEmptyComponent,
  numColumns = 1,
  itemHeight = 10,
  extendedState,
}: CustomRecyclerViewProps) => {
  const _renderRecycleView = (_type: any, item: any, index: any) => {
    return renderItem({ item, index })
  }

  useEffect(() => {
    setDataProvider((dataProvider) => dataProvider.cloneWithRows(data))
  }, [data])

  const [_dataProvider, setDataProvider] = useState(
    new DataProvider((r1, r2) => {
      return r1 !== r2
    }).cloneWithRows(data),
  )

  const [_layoutProvider] = useState(
    numColumns > 1
      ? new GridLayoutProvider(
          numColumns,
          (i) => 0,
          (i) => {
            return 1
          },
          (i) => itemHeight,
          0,
        )
      : new LayoutProvider(
          () => {
            return 'VSEL'
          },
          (type, dim) => {
            switch (type) {
              case 'VSEL':
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 64
                break
            }
          },
        ),
  )
  return (
    <>
      {data && data.length > 0 && (
        <RecyclerListView
          style={{ flex: 1 }}
          dataProvider={_dataProvider}
          layoutProvider={_layoutProvider}
          rowRenderer={_renderRecycleView}
          extendedState={extendedState}
        />
      )}
      {(!data || data.length === 0) && <ListEmptyComponent />}
    </>
  )
}

export { CustomRecyclerView }
